import { GET_AGENT_BRAND_LIST, GET_AGENT_BRANDS_BY_AGENT } from '../../endpoints';
import { IAgentBrand } from '../../types/agent';
import makeAuthenticatedRequest from '../base-api';

const agentBrandListQueryKey = ['agent-brand-list'];

const getAgentBrandsList = async (): Promise<{
  success: boolean;
  agentBrands?: IAgentBrand[];
  message?: string;
}> => {
  try {
    const response = await makeAuthenticatedRequest(GET_AGENT_BRAND_LIST, {
      method: 'GET',
    });

    const result = await response.json();

    if (!result.success) {
      throw new Error(result.message);
    }

    return result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

const getAgentBrandsByAgentId = async (agentId: string): Promise<{
  success: boolean;
  agentBrands?: IAgentBrand[];
  message?: string;
}> => {
  const response = await makeAuthenticatedRequest(
    GET_AGENT_BRANDS_BY_AGENT(agentId),
    { method: 'GET' }
  );
  const result = await response.json();
  if (!result.success) throw new Error(result.message);
  return result;
};

export { getAgentBrandsList, agentBrandListQueryKey, getAgentBrandsByAgentId };
